import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mobile-layout"
};
const _hoisted_2 = {
  class: "search-area"
};
const _hoisted_3 = {
  class: "search-input-box"
};
const _hoisted_4 = {
  class: "filter-box"
};
const _hoisted_5 = {
  class: "mobile-content"
};
const _hoisted_6 = {
  class: "dialog-footer"
};
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useUserinfoStore } from '@/store/userinfo';
import { useUserStore } from '@/stores/user';
import { useNotificationStore } from '@/stores/notification';
import request from '@/utils/request';
import { ElMessage } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';
import { compressImage } from '@/utils/imageCompression';
export default /*@__PURE__*/_defineComponent({
  __name: 'MobileLayout',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const userStore = useUserinfoStore();
    const userInfoStore = useUserStore();
    const notificationStore = useNotificationStore();
    const activeTab = ref(0);
    const showUserMenu = ref(false);
    const showPostDialog = ref(false);
    const showSearch = ref(false);
    const isMobile = ref(window.innerWidth <= 600);
    // 发布动态相关
    const postContent = ref('');
    const postTitle = ref('');
    const selectedImages = ref([]);
    const postCategoryId = ref(0);
    const postCategories = ref([]);
    // 搜索相关
    const searchQuery = ref('');
    const selectedCategory = ref('0');
    const categories = ref([]);
    // 根据当前路由计算页面标题
    const pageTitle = computed(() => {
      const routeTitles = {
        '/home': 'BUU校园墙',
        '/profile': '我的动态',
        '/notifications': '消息通知',
        '/user-info': '个人信息'
      };
      return routeTitles[route.path] || 'BUU校园墙';
    });
    // 返回上一页
    const onClickLeft = () => {
      router.back();
    };
    // 退出登录
    const handleLogout = async () => {
      try {
        await request.post('/user/logout');
      } catch (e) {
        // 忽略错误，继续清理本地信息
      }
      userStore.clearUserInfo();
      userInfoStore.clearUserInfo();
      router.push('/login');
    };
    // 切换搜索框显示状态
    const toggleSearch = () => {
      showSearch.value = !showSearch.value;
    };
    // 获取分类数据
    const fetchCategories = async () => {
      const res = await request.post('/category/select');
      if (res.data.code === 200) {
        const dbCategories = res.data.data.PostCategories.map(item => ({
          value: String(item.categoryId),
          text: item.categoryName
        }));
        // 搜索用categories，第一项为'全部'
        categories.value = [{
          value: '0',
          text: '全部'
        }, ...dbCategories];
        // 发布弹窗用postCategories，第一项为'请选择分类'
        postCategories.value = [{
          value: 0,
          label: '请选择分类'
        }, ...dbCategories.map(item => ({
          value: Number(item.value),
          label: item.text
        }))];
        // 只在手机端且未选择时重置selectedCategory为'0'
        if (isMobile.value && !selectedCategory.value) {
          selectedCategory.value = '0';
        }
      }
    };
    // 打开发布弹窗时重置分类为0
    const onAddPost = () => {
      fetchCategories();
      postCategoryId.value = 0;
      showPostDialog.value = true;
    };
    // 处理图片选择
    const handleImageChange = async file => {
      try {
        console.log('原始文件:', file.raw);
        const compressedFile = await compressImage(file.raw);
        console.log('压缩后的文件:', compressedFile);
        // 确保文件对象包含正确的类型和名称
        const processedFile = new File([compressedFile], compressedFile.name, {
          type: compressedFile.type || 'image/jpeg'
        });
        selectedImages.value.push(processedFile);
      } catch (error) {
        console.error('图片处理失败:', error);
        ElMessage.error('图片处理失败');
      }
    };
    // 处理图片移除
    const handleImageRemove = file => {
      const index = selectedImages.value.findIndex(img => img.name === file.name);
      if (index !== -1) {
        selectedImages.value.splice(index, 1);
      }
    };
    // 处理搜索
    const handleSearch = () => {
      // 触发父组件的搜索事件，保持与电脑端一致的参数格式
      const event = new CustomEvent('search', {
        detail: {
          postContent: searchQuery.value,
          postCategoryId: selectedCategory.value && selectedCategory.value !== '0' ? selectedCategory.value : undefined
        }
      });
      window.dispatchEvent(event);
      toggleSearch();
    };
    // 发布动态
    const handlePost = async () => {
      if (!postTitle.value.trim()) {
        ElMessage.warning('请输入标题');
        return;
      }
      if (!postContent.value.trim()) {
        ElMessage.warning('请输入内容');
        return;
      }
      // 手机端发布弹窗，分类为0时提示
      if (isMobile.value && postCategoryId.value === 0) {
        ElMessage.warning('请选择分类');
        return;
      }
      try {
        const formData = new FormData();
        const postJson = JSON.stringify({
          postContent: postContent.value,
          postTitle: postTitle.value,
          postCategoryId: postCategoryId.value
        });
        formData.append('post', new Blob([postJson], {
          type: 'application/json'
        }));
        // 确保每个图片都被正确添加到FormData中
        for (const image of selectedImages.value) {
          console.log('正在添加图片到FormData:', image);
          // 确保图片是File对象
          if (image instanceof File) {
            formData.append('images', image);
          } else {
            console.error('无效的图片对象:', image);
            ElMessage.error('图片格式错误');
            return;
          }
        }
        console.log('FormData内容:', Array.from(formData.entries()));
        const response = await request.post('/post/addpost', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          transformRequest: [data => data],
          // 防止axios自动转换FormData
          timeout: 30000 // 增加超时时间到30秒
        });
        if (response.data.code === 200) {
          ElMessage.success('发布成功');
          postContent.value = '';
          postTitle.value = '';
          selectedImages.value = [];
          postCategoryId.value = 0;
          showPostDialog.value = false;
          // 触发刷新帖子列表事件
          const event = new CustomEvent('refresh-posts');
          window.dispatchEvent(event);
          // 新增：发帖成功后刷新个人信息
          await userInfoStore.fetchUserInfo();
        } else {
          ElMessage.error(response.data.msg || '发布失败');
        }
      } catch (error) {
        console.error('发布失败:', error);
        if (error.response) {
          ElMessage.error(error.response.data?.msg || '发布失败，请重试');
        } else {
          ElMessage.error('网络错误，请检查网络连接');
        }
      }
    };
    // 监听窗口大小变化
    const handleResize = () => {
      isMobile.value = window.innerWidth <= 600;
    };
    onMounted(async () => {
      window.addEventListener('resize', handleResize);
      // 确保用户信息已加载
      if (!userInfoStore.isLoaded) {
        await userInfoStore.fetchUserInfo();
      }
      // 拉取通知数据，统计未读数
      await notificationStore.fetchNotifications();
      fetchCategories();
    });
    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_dropdown_item = _resolveComponent("van-dropdown-item");
      const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu");
      const _component_router_view = _resolveComponent("router-view");
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
      const _component_van_tabbar = _resolveComponent("van-tabbar");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        title: pageTitle.value,
        "left-text": _unref(route).path === '/home' ? '' : '返回',
        onClickLeft: _cache[2] || (_cache[2] = $event => _unref(route).path === '/home' ? null : onClickLeft),
        fixed: "",
        placeholder: ""
      }, {
        left: _withCtx(() => [_createVNode(_component_van_icon, {
          name: "wap-home-o",
          size: "20",
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/home'))
        })]),
        right: _withCtx(() => [_createVNode(_component_van_icon, {
          name: "search",
          class: "nav-icon",
          onClick: toggleSearch
        }), _createVNode(_component_van_icon, {
          name: "bell",
          badge: _unref(notificationStore).unreadCount > 0 ? _unref(notificationStore).unreadCount : '',
          onClick: _cache[1] || (_cache[1] = $event => _unref(router).push('/notifications'))
        }, null, 8, ["badge"])]),
        _: 1
      }, 8, ["title", "left-text"]), _withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_field, {
        modelValue: searchQuery.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => searchQuery.value = $event),
        placeholder: "搜索动态",
        clearable: ""
      }, {
        button: _withCtx(() => [_createVNode(_component_van_button, {
          size: "small",
          type: "primary",
          onClick: handleSearch
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("搜索")])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_cache[14] || (_cache[14] = _createElementVNode("label", {
        class: "mobile-category-label"
      }, "分类：", -1)), _createVNode(_component_van_dropdown_menu, {
        class: "mobile-category-dropdown"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_dropdown_item, {
          modelValue: selectedCategory.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => selectedCategory.value = $event),
          options: categories.value,
          placeholder: "请选择分类"
        }, null, 8, ["modelValue", "options"])]),
        _: 1
      })])], 512), [[_vShow, showSearch.value]]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_view)]), _createVNode(_component_van_tabbar, {
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => activeTab.value = $event),
        route: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
          to: "/home",
          icon: "home-o"
        }), _createVNode(_component_van_tabbar_item, {
          icon: "plus",
          onClick: onAddPost
        }), _createVNode(_component_van_tabbar_item, {
          to: "/profile",
          icon: "user-o"
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: showUserMenu.value,
        "onUpdate:show": _cache[7] || (_cache[7] = $event => showUserMenu.value = $event),
        position: "bottom",
        round: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [_createVNode(_component_van_cell, {
            title: "个人信息",
            "is-link": "",
            onClick: _cache[6] || (_cache[6] = $event => _unref(router).push('/user-info'))
          }), _createVNode(_component_van_cell, {
            title: "退出登录",
            "is-link": "",
            onClick: handleLogout
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_el_dialog, {
        modelValue: showPostDialog.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => showPostDialog.value = $event),
        title: "发布动态",
        width: isMobile.value ? '90%' : '500px',
        "close-on-click-modal": false,
        class: "post-dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: _cache[11] || (_cache[11] = $event => showPostDialog.value = false)
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handlePost
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("发布")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, null, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "标题",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: postTitle.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => postTitle.value = $event),
              placeholder: "请输入标题",
              maxlength: 50,
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "内容",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: postContent.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => postContent.value = $event),
              type: "textarea",
              rows: 4,
              placeholder: "分享新鲜事...",
              maxlength: 500,
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "分类",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: postCategoryId.value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => postCategoryId.value = $event),
              placeholder: "请选择分类"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(postCategories.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              action: "#",
              "list-type": "picture-card",
              "auto-upload": false,
              "on-change": handleImageChange,
              "on-remove": handleImageRemove,
              limit: 9
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "width"])]);
    };
  }
});